import { useLocationSpecificCreativeUpload } from "./useLocationSpecificCreativeUpload";
import { useMediaOwnerCreativeUpload } from "./useMediaOwnerCreativeUpload";

/**
 * Combines location-specific + media-owner creative uploads into a single API.
 */
export const useLocationCreativeUpload = () => {
  const {
    locationCreatives,
    isUploading: locationIsUploading,
    uploadingMap: locationUploadingMap,
    handleLocationFileChange,
    removeLocationCreative,
    handleLocationUrlSubmit,
    updateLocationCreativeDays,
  } = useLocationSpecificCreativeUpload();

  const {
    mediaOwnerCreatives,
    isUploading: mediaOwnerIsUploading,
    uploadingMap: mediaOwnerUploadingMap,
    handleMediaOwnerFileChange,
    removeMediaOwnerCreative,
    handleMediaOwnerUrlSubmit,
    updateMediaOwnerCreativeDays,
  } = useMediaOwnerCreativeUpload();

  // Overall uploading (true if any section is uploading)
  const isUploading = locationIsUploading || mediaOwnerIsUploading;

  return {
    locationCreatives,
    mediaOwnerCreatives,
    isUploading,
    /** Per-location uploading flags */
    locationUploadingMap,
    /** Per-media-owner uploading flags */
    mediaOwnerUploadingMap,
    handleLocationFileChange,
    handleMediaOwnerFileChange,
    removeLocationCreative,
    removeMediaOwnerCreative,
    handleLocationUrlSubmit,
    handleMediaOwnerUrlSubmit,
    updateLocationCreativeDays,
    updateMediaOwnerCreativeDays,
  };
};
